import { NavLink } from "react-router-dom";
import "../style/articleLayout.css";

export default function RelatedTopics({ topics = [], currentPath }) {
  const visibleTopics = topics.filter((topic) => topic.to !== currentPath).slice(0, 4);

  if (!visibleTopics.length) {
    return null;
  }

  return (
    <section className="related-topics">
      <div className="related-topics-header">
        <span>Keep learning</span>
        <h2>Related topics</h2>
      </div>

      <div className="related-topics-grid">
        {visibleTopics.map((topic) => (
          <NavLink className="related-topic-card" to={topic.to} key={topic.to}>
            <span>{topic.category}</span>
            <strong>{topic.title}</strong>
          </NavLink>
        ))}
      </div>
    </section>
  );
}
